import {EventUpdateSubscription} from 'src/openapi/models/EventUpdateSubscription';

const updateFamilies = (
    eventUpdateSubscriptions: EventUpdateSubscription[],
    source: string,
    family: string,
): EventUpdateSubscription[] => {
    return eventUpdateSubscriptions.map(subscription => {
        const hasSource = subscription.source === source;
        const hasFamily = subscription.families.includes(family);

        if (hasSource && !hasFamily) {
            return {
                ...subscription,
                families: [...subscription.families, family],
            };
        }

        return subscription;
    });
};

export const groupCheckedIds = (
    checkedIds: string[],
    allSources: string[],
    allFamilies: string[],
): EventUpdateSubscription[] => {
    return checkedIds.reduce((eventUpdateSubscriptions, id) => {
        const [source, family] = id.split(/-(.+)/).slice(0, 2);

        const hasValidSource = allSources.includes(source);
        const hasValidFamily = allFamilies.includes(family);

        if (!hasValidSource || !hasValidFamily) {
            return eventUpdateSubscriptions;
        }

        const existingEventUpdateSubscription =
            eventUpdateSubscriptions.find(item => item.source === source);

        if (existingEventUpdateSubscription) {
            return updateFamilies(eventUpdateSubscriptions, source, family);
        }

        return [...eventUpdateSubscriptions, {source, families: [family]}];
    }, [] as EventUpdateSubscription[]);
};
